'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var componentHasPropTypes = exports.componentHasPropTypes = function componentHasPropTypes(requiredPropTypes) {

  return function (props, propName, componentName) {
    if (props[propName]) {
      var prop = props[propName];
      var widgetName = prop.type.name;
      var propTypes = prop.type.propTypes || {};
      if (prop.type.WrappedComponent) {
        // For containers, check the propTypes of the WrappedComponent
        widgetName = prop.type.WrappedComponent.name;
        propTypes = prop.type.WrappedComponent.propTypes || {};
      }
      var missingProps = [];
      requiredPropTypes.forEach(function (requiredProp) {
        if (!propTypes[requiredProp]) {
          missingProps.push(requiredProp);
        }
      });
      if (missingProps.length > 0) {
        return new Error('`' + componentName + '`. ' + 'The component passed as ' + '`' + propName + '` ' + '(' + widgetName + ') is missing the following PropType(s): ' + missingProps);
      }
    }
    //assume all ok
    return null;
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/utils/CustomPropTypeValidation.js
// module id = 228
// module chunks = 10